<template>
    <CNCSchedule></CNCSchedule>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CNCSchedule = defineAsyncComponent(() =>
    import(
        "../../components/CNC/DepartmentSchedule.vue"
        )
);

export default {
    name: "CNC_Schedule", //The name you are in should not equal the name of the component you are importing.
    components: { CNCSchedule, AuthLayout },
};
</script>
